(() => {
  const KEY = '__fsCompareProductsInitialized';
  if (window[KEY]) return;
  window[KEY] = true;

  const instances = new WeakMap();

  const initCompareBlock = (block) => {
    if (!block) return null;

    const range = block.querySelector('[data-fs-compare-range]');
    if (!range) return null;

    const updatePosition = () => {
      block.style.setProperty('--position', `${range.value}%`);
    };

    const onDragStart = () => {
      block.classList.add('is-dragging');
    };

    const onDragEnd = () => {
      block.classList.remove('is-dragging');
    };

    const updateRotatedDimensions = () => {
      const { width, height } = block.getBoundingClientRect();
      block.style.setProperty('--fs-compare-rotated-width', `${height}px`);
      block.style.setProperty('--fs-compare-rotated-height', `${width}px`);
    };

    let resizeObserver = null;
    let removeResizeListener = null;

    updatePosition();
    updateRotatedDimensions();

    range.addEventListener('input', updatePosition);
    range.addEventListener('change', updatePosition);
    range.addEventListener('pointerdown', onDragStart);
    range.addEventListener('pointerup', onDragEnd);
    range.addEventListener('pointercancel', onDragEnd);
    range.addEventListener('pointerleave', onDragEnd);
    range.addEventListener('blur', onDragEnd);

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(updateRotatedDimensions);
      resizeObserver.observe(block);
    } else {
      window.addEventListener('resize', updateRotatedDimensions);
      removeResizeListener = () => window.removeEventListener('resize', updateRotatedDimensions);
    }

    return () => {
      range.removeEventListener('input', updatePosition);
      range.removeEventListener('change', updatePosition);
      range.removeEventListener('pointerdown', onDragStart);
      range.removeEventListener('pointerup', onDragEnd);
      range.removeEventListener('pointercancel', onDragEnd);
      range.removeEventListener('pointerleave', onDragEnd);
      range.removeEventListener('blur', onDragEnd);
      if (resizeObserver) resizeObserver.disconnect();
      if (removeResizeListener) removeResizeListener();
    };
  };

  const initSection = (section) => {
    if (!section || instances.has(section)) return;

    const compareBlocks = [...section.querySelectorAll('[data-fs-compare]')];
    const cleanups = compareBlocks.map(initCompareBlock).filter(Boolean);

    instances.set(section, () => {
      cleanups.forEach((cleanup) => cleanup());
    });
  };

  const cleanupSection = (section) => {
    const cleanup = instances.get(section);
    if (!cleanup) return;
    cleanup();
    instances.delete(section);
  };

  const initAll = () => {
    document.querySelectorAll('[data-fs-compare-products]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const loaded =
      (event.target.matches && event.target.matches('[data-fs-compare-products]') && event.target) ||
      event.target.querySelector('[data-fs-compare-products]');
    if (!loaded) return;
    initSection(loaded);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const unloaded =
      (event.target.matches && event.target.matches('[data-fs-compare-products]') && event.target) ||
      event.target.querySelector('[data-fs-compare-products]');
    if (!unloaded) return;
    cleanupSection(unloaded);
  });
})();
